import { render } from "./MasterAnswer.vue?vue&type=template&id=439d12fc&scoped=true&bindings={\"commentary\":\"props\",\"answers\":\"props\",\"answer\":\"props\",\"images\":\"props\",\"result\":\"setup\",\"rightAnswer\":\"setup\"}"
import script from "./MasterAnswer.vue?vue&type=script&lang=ts"
export * from "./MasterAnswer.vue?vue&type=script&lang=ts"

import "./MasterAnswer.vue?vue&type=style&index=0&id=439d12fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-439d12fc"

export default script